module.exports = __webpack_public_path__ + "static/bilgewater-champs.6c862319.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bilgewater-champs.jpg
// module id = 512
// module chunks = 35783957827783